<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="assetActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheAssetActivityPage',
  computed: { ...mapGetters({ assetActivity: 'asset/getAssetActivity' }) },
  methods: { ...mapActions({ fetch: 'asset/fetchAssetActivitiesByAssetID' }) },
  beforeMount() {
    this.fetch({ asset_id: this.$route.params.id })
  }
}
</script>
